var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentMethods && _vm.paymentMethods.payment_link)?_c('div',{staticClass:"pt-2"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("\n        Será gerado um link para pagamento posterior através de\n        "),_c('b',[_vm._v("Cartão de Crédito")]),_vm._v(". Após realizar o pagamento utilizando o link gerado, o pedido\n        será confirmado automaticamente.\n    ")])
}]

export { render, staticRenderFns }